<template>
  <div v-resize="onResize">
    <!-- Login Window If No User -->
    <!--                         -->
    <v-app v-if="!user">
      <v-content>
        <login />
      </v-content>
    </v-app>
    <!-- Start of Application -->
    <!--                      -->
    <v-app v-if="user">
      <!-- Side Navigation -->
      <!--                 -->
      <v-navigation-drawer class="hidden-lg-and-up" absolute v-model="sideNav" style="top: 50px">
        <v-list>
          <v-list-tile value="true" v-for="(item, i) in menuItems" :key="i" :to="item.route">
            <v-list-tile-action>
              <v-icon v-html="item.icon"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-text="item.title"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <!-- Menu Toolbar -->
      <!--              -->
      <v-toolbar dark class="secondary">
        <v-toolbar-side-icon class="hidden-lg-and-up" @click.stop="sideNav = !sideNav"></v-toolbar-side-icon>
        <router-link to="/" tag="span" style="cursor: pointer"><img src="./assets/logoDark.png" height="50px"></router-link>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <!-- Regular Search Button -->
          <v-btn class="hidden-xs-only" @click="showSearch = !showSearch" flat><v-icon left>search</v-icon>Search</v-btn>
          <!-- Search Button without Text -->
          <v-btn class="hidden-sm-and-up" @click="showSearch = !showSearch" flat fab><v-icon>search</v-icon></v-btn>
          <v-btn class="hidden-md-and-down" flat v-for="item in menuItems" :key="item.title" :to="item.route" v-if="!item.showMenu || (item.showMenu && (user.permissions.others.showAllLeads || user.if_sales_rep))">
            <v-icon left>{{ item.icon }}</v-icon>
            {{ item.title }}</v-btn>
          <!-- <v-btn flat @click="onLogout" v-if="userIdAuthenticated"><v-icon left>exit_to_app</v-icon>Logout</v-btn> -->
        </v-toolbar-items>
        <v-badge overlap color="red" class="ml-2">
          <span slot="badge">{{notifications && notifications.length > 0 ? notifications.length : 0}}</span>
          <v-avatar @click="showRightSideBar = !showRightSideBar" style="cursor: pointer">
            <avatar :username="userFullName" :src="user.avatar ? user.avatar : undefined"></avatar>
          </v-avatar>
          <!-- <v-icon @click.stop="showRightSideBar = !showRightSideBar" large color="white" style="cursor: pointer">notifications</v-icon> -->
        </v-badge>
      </v-toolbar>
      <!-- Search Box -->
      <v-toolbar v-if="showSearch" dark color="grey darken-1" height="60px">
        <v-layout row wrap>
          <v-flex xs2 style="margin-top: 20px">
            <v-btn icon @click="showSearch = false"><v-icon>cancel</v-icon></v-btn>
          </v-flex>
          <v-flex xs8 style="margin-top: 30px">
            <v-autocomplete autofocus @input="executeSearch" color="white" prepend-icon="search" v-model="selectedContact" :items="searchBox" label="Search Customers and Projects" return-object item-text="search" item-value="id">
            <v-icon dark>people</v-icon>
              <template slot="selection" slot-scope="data">
                  {{ data.item.name }}
              </template>
              <template slot="item" slot-scope="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <v-icon style="margin-right:10px">{{data.item.type === 'Project' ? 'ballot' : data.item.type === 'Lead' ? 'person_outline' : 'person'}}</v-icon>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs2 class="text-xs-right" style="margin-top: 20px; padding-left:20px">
            <v-btn @click="showSearch = false" :to="'/customers'" flat large icon><v-icon large dark>people</v-icon></v-btn>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <!-- End: Search Box -->
      <!-- Broadcast Notification: Update Available -->
      <div>
        <v-alert :value="userState && userState.updateNotify" type="error">A new update is available. Close this message and REFRESH your browser to get the latest changes!<v-btn @click="clearUpdateNotification" dark small icon><v-icon>cancel</v-icon></v-btn></v-alert>
      </div>
      <!-- Main Content -->
      <!--              -->
      <v-content>
        <v-progress-linear v-if="loading" :indeterminate="true" color="primary"></v-progress-linear>
        <router-view :key="$route.fullPath" :projectButtonSelection="projectButtonSelection" :notifications="notifications"/>
      </v-content>
      <!-- Right Sidebar -->
      <!--                      -->
        <v-navigation-drawer width="600" temporary right v-model="showRightSideBar" fixed app>
          <v-toolbar class="primary" dark flat>
            <v-list>
              <v-list-tile>
                <v-list-tile-title class="title">
                  <v-icon dark left style="margin-right: 10px">settings</v-icon>Settings
                </v-list-tile-title>
                <v-spacer></v-spacer>
                 <v-icon @click="showRightSideBar = !showRightSideBar" style="cursor: pointer">cancel</v-icon>
              </v-list-tile>
            </v-list>
          </v-toolbar>
          <v-divider></v-divider>
          <!-- Settings and Admin -->
          <v-list class="pt-0" dense>
            <v-divider></v-divider>
            <v-list-tile v-for="item in rightSideBarAdmin" :key="item.title" @click="rightSideMenu(item.event)">
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-toolbar class="primary" dark flat>
            <v-list>
              <v-list-tile>
                <v-list-tile-title class="title">
                  <v-icon dark left style="margin-right: 10px">notification_important</v-icon>Notifications
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-toolbar>
          <v-divider></v-divider>
          <!-- Notifications -->
          <v-list three-line>
            <template v-for="(item, index) in notifications">
              <v-list-tile :key="index" avatar>
                  <v-list-tile-avatar @click="notificationUrl(item.url)" style="cursor: pointer">
                    <v-avatar color="purple">
                      <v-icon dark>{{ item.icon }}</v-icon>
                    </v-avatar>
                  </v-list-tile-avatar>
                  <v-list-tile-content @click="notificationUrl(item.url)" style="cursor: pointer">
                    <v-list-tile-title>{{item.timestamp.seconds | moment("from")}}</v-list-tile-title>
                    <v-list-tile-sub-title v-html="item.title"></v-list-tile-sub-title>
                  </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon @click="clearNotification(item.id)"><v-icon>cancel</v-icon></v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </v-navigation-drawer>
      <!-- Footer -->
      <!--        -->
      <v-footer app :height="activateProjectButtons ? '100px' : '30px'">
        <v-layout row wrap>
          <!-- Mobile Projects Footer Buttons -->
          <v-layout class="elevation-1" row v-for="(buttons, index) in projectMobileButtons" :key="index" v-if="activateProjectButtons">
            <v-layout pt-2 pb-2 align-center justify-center column fill-height >
              <div class="text-xs-center" @click="projectButtonSelection = buttons.title">
                <div><v-icon>{{buttons.icon}}</v-icon></div>
                <div><span class="font-weight-bold">{{buttons.title}}</span></div>
              </div>
            </v-layout>
          </v-layout>
          <!-- End: Mobile Projects Footer Buttons -->
          <v-flex xs12>
            <v-toolbar height="32px" class="primary white--text">
              <v-toolbar-title class="caption">&copy; PoolTracker 2020</v-toolbar-title>
            </v-toolbar>
          </v-flex>
        </v-layout>
      </v-footer>
      <!-- Admin Dialog -->
      <!-- <v-dialog v-model="adminDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <admin v-if="adminDialog" @closeDialog="adminDialog = false" />
      </v-dialog> -->
      <!-- End: Admin Dialog -->
    </v-app>
  </div>
</template>

<script>
import Avatar from 'vue-avatar'
import Login from '@/components/authentication/Login'
import Admin from '@/components/admin/Admin'
import _ from 'lodash'
import { db } from './firebaseInit'

export default {
  data () {
    return {
      userState: null,
      windowWidth: null,
      projectButtonSelection: null,
      showSearch: false,
      selectedContact: null,
      adminDialog: false,
      sideNav: false,
      menuItems: [
                  {icon: 'home', title: 'Home', route: '/home'},
                  {icon: 'calendar_today', title: 'Scheduler', route: '/scheduler'},
                  {icon: 'people_outline', title: 'Leads', route: '/leads', showMenu: true},
                  {icon: 'ballot', title: 'Pre-Construction', route: '/projects/Pre-Construction'},
                  {icon: 'developer_board', title: 'Construction', route: '/projects/Construction'},
                  {icon: 'group', title: 'Customers', route: '/customers'}
                  // {icon: 'group', title: 'Vendors', route: '/vendors'}
                  // {icon: 'assignment_ind', title: 'Vendors', route: '/vendors'}
      ],
      rightSideBarAdmin: [{icon: 'settings', title: 'Settings', event: 'admin'},
                          // {icon: 'group', title: 'Users', event: '/users'},
                          // {icon: 'ballot', title: 'Task Templates', event: '/tasks/templates'},
                          // {icon: 'people', title: 'Vendors', event: '/vendors'},
                          {icon: 'save_alt', title: 'Logout', event: 'logout'}
      ],
      rightSideBarNotifications: [{avatarType: 'icon', icon: 'home', date: '3 Hours Ago', title: 'Project: Smith - West Oaks', message: 'New Pool Print Available', event: '/leads'},
                                  {avatarType: 'icon', icon: 'group', date: '3 Hours Ago', title: 'General Announcement', message: 'Turn in lead sheets today', event: '/customers'},
                                  {avatarType: 'icon', icon: 'ballot', date: '3 Hours Ago', title: 'Project: Gallegos - Winter Garden', message: 'New Change Order Available', event: '/projects'}
      ],
      projectMobileButtons: [ {icon: 'ballot', title: 'DETAILS'},
                              {icon: 'check_box', title: 'TASKS'},
                              {icon: 'library_books', title: 'NOTES'},
                              {icon: 'border_outer', title: 'PLANS'},
                              {icon: 'perm_media', title: 'FILES'},
                              {icon: 'photo_camera', title: 'PHOTOS'}
      ],
      showRightSideBar: false
    }
  },
  name: 'App',
  mounted () {
    this.getSearchData()
  },
  computed: {
    notifications () {
      let getNotifications = this.$store.getters.notifications
      getNotifications.forEach(notification => {
        notification.url = notification.url.replace(this.$store.getters.clientSettings.baseUrl, '')
      })
      return _.orderBy(getNotifications, 'timestamp.seconds', 'desc')
    },
    activateProjectButtons () {
      return this.projectButtonSelection && this.$route.name === 'Project'
    },
    searchBox () {
      let contacts = this.$store.getters.getContactSearchList
      contacts = contacts.map(m => ({ ...m, search: m.name + m.address + m.city }))
      // If Phone
      contacts = contacts.map(m => ({ ...m, search: m.phone ? m.search + m.phone : m.search }))
      let projects = this.$store.getters.projectSearch
      projects = projects.map(m => ({ ...m, search: m.name + m.job_number + m.address + m.city }))
      let join = projects.concat(contacts)
      return join
    },
    loading () {
      return this.$store.getters.loading
    },
    user () {
      const user = this.$store.getters.user
      return user
    },
    userFullName () {
      return this.user.first_name + ' ' + this.user.last_name
    }
  },
  watch: {
    projectButtonSelection () {
    },
    windowWidth () {
      if (this.windowWidth <= 960) {
        this.projectButtonSelection = 'DETAILS'
      } else {
        this.projectButtonSelection = null
      }
    },
    user (value) {
      if (value !== null && value !== undefined) {
        this.loggedIn = true
        this.$store.dispatch('notifications')
        this.getUserState()
      } else {
        this.loggedIn = null
      }
    }
  },
  methods: {
    clearUpdateNotification () {
      db.collection('users').doc(this.user.id).update({ updateNotify: false })
    },
    getUserState () {
      db.collection('users').doc(this.user.id).onSnapshot(doc => {
        this.userState = doc.data()
      })
    },
    getSearchData () {
      if (this.$store.getters.user) {
        this.$store.dispatch('getSearchContacts')
        this.$store.dispatch('projectSearch')
      } else {
        setTimeout(() => {
          this.getSearchData()
        }, 500)
      }
    },
    notificationUrl (url) {
      this.$router.push(url)
    },
    clearNotification (id) {
      this.$store.dispatch('clearNotification', id)
    },
    onResize () {
      this.windowWidth = window.innerWidth
    },
    executeSearch () {
      if (this.selectedContact.type === 'Project') {
        this.$router.push('/project/' + this.selectedContact.id)
      } else {
        this.$router.push('/customers/' + this.selectedContact.id)
      }
      this.selectedContact = null
      this.showSearch = false
    },
    logout () {
      this.$router.push('/login')
      this.$store.dispatch('signUserOut')
    },
    rightSideMenu (event) {
      if (event === 'logout') {
        this.logout()
      } else if (event === 'admin') {
        // this.adminDialog = true
        this.$router.push('/admin')
      } else {
        this.$router.push(event)
      }
    }
  },
  components: {
    Login,
    Avatar,
    Admin
  }
}
</script>

<style>
showMenu {
  display: none;
}
</style>




// WEBPACK FOOTER //
// src/App.vue